import auth from './auth/index';
import activate from './activate/index';
var path = '/users';
var users = function (url) { return function () { return ({
    auth: auth("" + url + path),
    activate: activate("" + url + path),
}); }; };
export default users;
